import { render, staticRenderFns } from "./ShopifyThemeSettingsModal.vue?vue&type=template&id=4d0f5d44&"
import script from "./ShopifyThemeSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./ShopifyThemeSettingsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports